export default __webpack_public_path__ + "static/media/shopify_logo.d2d8362f.png";